import {
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React from "react";

import PageContext from "../../context";
import PageDomain from "../../domain";
import "./style.css";

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: "rgba(0, 0, 0, 0.84)",
  },
  tooltip: {
    minWidth: 150,
    backgroundColor: "rgba(0, 0, 0, 0.84)",
    whiteSpace: "nowrap",
  },
}));

const CustomTooltip = (props) => {
  const classes = useStylesBootstrap();
  return <Tooltip classes={classes} {...props} arrow />;
};

const StatTable = () => {
  const { tableDataset, packageBreakdown } = React.useContext(PageContext);
  const calculatedTotal = React.useMemo(() => {
    return PageDomain.calculateTotalByTableData(tableDataset);
  }, [tableDataset]);

  const { packagesList = {} } = packageBreakdown;

  const packageBreakdownMapping = {
    newCard: "new.card",
    newCash: "new.cash",
    newTotal: "new.total",
    renewCard: "renew.card",
    renewCash: "renew.cash",
    renewTotal: "renew.total",
    cardTotal: "total.card",
    cashTotal: "total.cash",
    total: "total",
  };

  const getTooltipData = (criteria = "") => {
    const [category, type] = criteria.split(".");

    return (
      <Grid container direction="row">
        {Object.entries(packagesList).map(([key, value]) => (
          <>
            <Typography className="w-half">{key}</Typography>
            <Typography className="w-half" style={{ textAlign: "center" }}>
              {type === "total" || (category === "total" && !type)
                ? `${value[category].card + value[category].cash}`
                : category === "total"
                ? value[category][type]
                : value[category][type]}
            </Typography>
          </>
        ))}
      </Grid>
    );
  };

  return (
    <Paper className="real-time-kpi-stat-table-root" elevation={0}>
      <TableContainer>
        <Table className="real-time-kpi-stat-table">
          <TableHead>
            <TableRow>
              <TableCell>Operator</TableCell>
              <TableCell align="right">Category</TableCell>
              <TableCell align="right">Comments</TableCell>
              <TableCell align="right">Card</TableCell>
              <TableCell align="right">Cash</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(tableDataset).map((current) => {
              const { operator, dataset } = current;
              const operatorName = `${operator.name} (${operator.memberId})`;
              return (
                <>
                  <TableRow>
                    <TableCell rowSpan={3} className="operator-name">
                      {operatorName}
                    </TableCell>
                    <TableCell align="right">new</TableCell>
                    <TableCell align="right">{dataset.new.comments}</TableCell>
                    <TableCell align="right">{dataset.new.card}</TableCell>
                    <TableCell align="right">{dataset.new.cash}</TableCell>
                    <TableCell align="right">{dataset.total.new}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="right">renew</TableCell>
                    <TableCell align="right">
                      {dataset.renew.comments}
                    </TableCell>
                    <TableCell align="right">{dataset.renew.card}</TableCell>
                    <TableCell align="right">{dataset.renew.cash}</TableCell>
                    <TableCell align="right">{dataset.total.renew}</TableCell>
                  </TableRow>
                  <TableRow className="operator-individual-total">
                    <TableCell align="right">total</TableCell>
                    <TableCell align="right">
                      {dataset.total.comments}
                    </TableCell>
                    <TableCell align="right">{dataset.total.card}</TableCell>
                    <TableCell align="right">{dataset.total.cash}</TableCell>
                    <TableCell align="right">
                      {dataset.total.new + dataset.total.renew}
                    </TableCell>
                  </TableRow>
                </>
              );
            })}
            <TableRow className="category-individual-total">
              <TableCell align="right" colSpan={2}>
                new
              </TableCell>
              <TableCell align="right">
                {calculatedTotal.new.comments}
              </TableCell>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.newCard)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.new.card}
                </TableCell>
              </CustomTooltip>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.newCash)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.new.cash}
                </TableCell>
              </CustomTooltip>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.newTotal)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.new.card + calculatedTotal.new.cash}
                </TableCell>
              </CustomTooltip>
            </TableRow>
            <TableRow className="category-individual-total">
              <TableCell align="right" colSpan={2}>
                renew
              </TableCell>
              <TableCell align="right">
                {calculatedTotal.renew.comments}
              </TableCell>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.renewCard)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.renew.card}
                </TableCell>
              </CustomTooltip>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.renewCash)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.renew.cash}
                </TableCell>
              </CustomTooltip>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.renewTotal)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.renew.card + calculatedTotal.renew.cash}
                </TableCell>
              </CustomTooltip>
            </TableRow>
            <TableRow className="grand-individual-total">
              <TableCell align="right" colSpan={2}>
                Total
              </TableCell>
              <TableCell align="right">
                {calculatedTotal.total.comments}
              </TableCell>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.cardTotal)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.total.card}
                </TableCell>
              </CustomTooltip>
              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.cashTotal)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.total.cash}
                </TableCell>
              </CustomTooltip>

              <CustomTooltip
                title={getTooltipData(packageBreakdownMapping.total)}
              >
                <TableCell align="right" className="total-cell">
                  {calculatedTotal.total.cash + calculatedTotal.total.card}
                </TableCell>
              </CustomTooltip>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default StatTable;
